import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SproutIcon from '../components/Common/SproutIcon';
import { FileSearch } from '../components/Common/icons';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ textAlign: 'center', py: 10, color: 'text.secondary' }}>
      <SproutIcon icon={FileSearch} size={48} />
      <Typography variant="h4" sx={{ mt: 2, color: 'text.primary' }}>
        Page not found
      </Typography>
      <Typography variant="body1" sx={{ mt: 1, mb: 3 }}>
        This component page doesn't exist or has moved.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/')}>
        Back to overview
      </Button>
    </Box>
  );
};

export default NotFound;
